module.exports = __webpack_public_path__ + "33ba32aa8ef0b36ae5be725e456f6f48.pdf";